import './style.scss';
import $ from "jquery";
import { gsap } from 'gsap';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

$(document).ready(() => {
    $('.wp-block-thefuturblocks-latest-posts__gallery-gutenberg .blocks-gallery-grid').flickity({
        pageDots: false,
        prevNextButtons: false,
        groupCells: false,
        contain: true,
        imagesLoaded: true,
        percentPosition: true,
        wrapAround: true,
        autoPlay: 4000,
    });

    $('.wp-block-thefuturblocks-latest-posts__gallery-button--prev').on( 'click', function() {
        $('.wp-block-thefuturblocks-latest-posts__gallery-gutenberg .blocks-gallery-grid').flickity('previous');
    });

    $('.wp-block-thefuturblocks-latest-posts__gallery-button--next').on( 'click', function() {
        $('.wp-block-thefuturblocks-latest-posts__gallery-gutenberg .blocks-gallery-grid').flickity('next');
    });

    //QUOTE
    function quoteFunction() {
        if($(".wp-block-thefuturblocks-latest-posts__article.format-quote").length > 0) {
            $(".wp-block-thefuturblocks-latest-posts__article.format-quote").each(function() {
                const self = $(this),
                    sign = self.find(".wp-block-thefuturblocks-latest-posts__quote-gutenberg-icon"),
                    svg = self.find(".thefutur-icons");
                    
                sign.on("mousemove", moveIn);
                sign.on("mouseleave", moveOut);

                function moveIn(e){
                    var boundingRect = sign[0].getBoundingClientRect();
                    var relX = e.clientX - boundingRect.left;
                    var relY = e.clientY - boundingRect.top;

                    gsap.to(svg, {
                        duration: 0.3,
                        x: (relX - boundingRect.width/2) / boundingRect.width * 20,
                        y: (relY - boundingRect.height/2) / boundingRect.width * 20,
                        ease: "sine.out",
                        overwrite: "auto"
                    })
                }

                function moveOut(){
                    gsap.to(svg, {
                        duration: 0.3,
                        x: 0,
                        y: 0,
                        overwrite: "auto"
                    })
                }
            })
        }
    }
    quoteFunction();
});